var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadFileIconV2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4531",
    "data-name": "Rectangle 4531",
    width: 17.483,
    height: 16.026,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13719",
    "data-name": "Group 13719",
    transform: "translate(-1090 -2456)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_569",
    "data-name": "Ellipse 569",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(1090 2456)",
    fill: "#014fe0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11154",
    "data-name": "Group 11154",
    transform: "translate(1101 2468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11152",
    "data-name": "Group 11152",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44609",
    "data-name": "Path 44609",
    d: "M8.737,173.5H2.318A2.191,2.191,0,0,1,0,171.193q0-1.354,0-2.709a.736.736,0,0,1,.73-.811.74.74,0,0,1,.726.816c0,.91,0,1.821,0,2.731a.74.74,0,0,0,.812.821H15.221a.733.733,0,0,0,.8-.808c0-.941,0-1.882,0-2.822a.725.725,0,0,1,1.429-.189,1.1,1.1,0,0,1,.025.27c0,.918,0,1.836,0,2.754a2.181,2.181,0,0,1-2.257,2.251q-3.244,0-6.487,0",
    transform: "translate(0 -157.474)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44610",
    "data-name": "Path 44610",
    d: "M76.243,10.859v-.32q0-4.835,0-9.671A1.284,1.284,0,0,1,76.283.51a.713.713,0,0,1,.77-.505A.737.737,0,0,1,77.7.671c.007.083,0,.167,0,.25q0,4.824,0,9.648v.279c.08-.055.135-.088.185-.127L80.159,8.9a.728.728,0,1,1,.924,1.12q-1.8,1.446-3.606,2.885a.725.725,0,0,1-1.013,0q-1.761-1.4-3.518-2.813a.725.725,0,1,1,.909-1.128c.726.574,1.447,1.153,2.17,1.729.058.046.118.09.217.165",
    transform: "translate(-68.23 0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFileIconV2);
export default __webpack_public_path__ + "static/media/download-file-icon-v2.772fa399be9416f2819e4a3ef841ecde.svg";
export { ForwardRef as ReactComponent };